const InvestorsScreen = () => {

    return(
        <p>Investors Screen</p>
    )
}

export default InvestorsScreen